/* Rêve de Mur : pack 2+1 (fenêtre) et ajouts rapides dans le panier */
import { CartLinesUpdateEvent } from '@shopify/events';

const SEUIL = 3000;
const eur = (c) => (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: 'EUR' });
const plural = (k, one, many) => (k > 1 ? many : one);

/** Ajoute plusieurs variantes et laisse le thème rafraîchir le panier */
async function addItems(items, source) {
  const ids = [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
  const deferred = CartLinesUpdateEvent.createPromise();
  source.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })),
      promise: deferred.promise,
    })
  );
  const getCart = () => fetch(Theme.routes.cart_url + '.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
  try {
    const res = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: ids.join(',') }),
    }).then((r) => r.json());
    const cart = await getCart();
    const failed = Boolean(res.status);
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, sections: failed ? undefined : res.sections, didError: failed, source: 'rdm-pack' },
    });
    if (failed) throw new Error(res.description || res.message || "Impossible d'ajouter ces stickers");
    return cart;
  } catch (e) {
    deferred.reject(e);
    throw e;
  }
}

function openDrawer() {
  const drawer = document.querySelector('theme-drawer#cart-drawer');
  if (drawer && typeof drawer.open === 'function') {
    if (!drawer.isOpen) drawer.open();
  } else {
    window.location.href = Theme.routes.cart_url;
  }
}

/* ---------- Fenêtre « Composez votre pack » ---------- */
function packState(dialog) {
  const boxes = [...dialog.querySelectorAll('.rdm-pack__item input')];
  const sel = boxes.filter((b) => b.checked);
  const prices = sel.map((b) => +b.dataset.price).sort((a, b) => a - b);
  const nFree = Math.floor(sel.length / 3);
  const free = prices.slice(0, nFree).reduce((a, b) => a + b, 0);
  const total = prices.reduce((a, b) => a + b, 0);
  return { boxes, sel, nFree, free, total, pay: total - free };
}

function renderPack(dialog) {
  const s = packState(dialog);
  const k = s.sel.length;
  const rem = k % 3;
  const filled = k === 0 ? 0 : rem === 0 ? 3 : rem;
  dialog.querySelectorAll('[data-rdm-pack-slots] .rdm-up__slot').forEach((el, i) => el.classList.toggle('is-on', i < filled));

  s.boxes.forEach((b) => b.closest('.rdm-pack__item').classList.remove('is-free'));
  const cheapest = [...s.sel].sort((a, b) => +a.dataset.price - +b.dataset.price).slice(0, s.nFree);
  cheapest.forEach((b) => b.closest('.rdm-pack__item').classList.add('is-free'));

  const msg = dialog.querySelector('[data-rdm-pack-msg]');
  const price = dialog.querySelector('[data-rdm-pack-price]');
  const btn = dialog.querySelector('[data-rdm-pack-add]');
  if (k === 0) msg.innerHTML = 'Cochez 3 stickers pour en avoir un offert.';
  else if (rem === 0) msg.innerHTML = `<b>${s.nFree > 1 ? s.nFree + ' stickers offerts' : '1 sticker offert'}</b>, le moins cher du pack.`;
  else msg.innerHTML = `Encore <b>${3 - rem} ${plural(3 - rem, 'sticker', 'stickers')}</b> et le moins cher est offert.`;

  if (k === 0) price.innerHTML = '';
  else {
    const ship = s.pay >= SEUIL ? 'livraison offerte' : '+ 1,99 € de livraison';
    price.innerHTML = s.free
      ? `<b>${eur(s.pay)}</b> <s>${eur(s.total)}</s> · ${ship}`
      : `<b>${eur(s.pay)}</b> · ${ship}`;
  }
  btn.disabled = k === 0;
  btn.textContent = k === 0 ? 'Ajouter au panier' : `Ajouter ${k} ${plural(k, 'sticker', 'stickers')} au panier`;
}

document.addEventListener('click', async (e) => {
  const opener = e.target.closest('[data-rdm-pack-open]');
  if (opener) {
    const dialog = document.getElementById('rdm-pack');
    if (!dialog) return;
    e.preventDefault();
    renderPack(dialog);
    dialog.showModal();
    return;
  }
  if (e.target.closest('[data-rdm-pack-close]')) {
    e.target.closest('dialog')?.close();
    return;
  }
  const dlg = e.target instanceof HTMLDialogElement && e.target.classList.contains('rdm-pack') ? e.target : null;
  if (dlg) { dlg.close(); return; }

  const packAdd = e.target.closest('[data-rdm-pack-add]');
  if (packAdd) {
    const dialog = packAdd.closest('dialog');
    const err = dialog.querySelector('[data-rdm-pack-err]');
    const s = packState(dialog);
    if (!s.sel.length) return;
    packAdd.disabled = true;
    packAdd.textContent = 'Ajout en cours…';
    err.hidden = true;
    try {
      await addItems(s.sel.map((b) => ({ id: +b.value, quantity: 1 })), packAdd);
      dialog.close();
      s.sel.forEach((b) => (b.checked = false));
      openDrawer();
    } catch (ex) {
      err.textContent = ex.message;
      err.hidden = false;
    } finally {
      renderPack(dialog);
    }
    return;
  }

  const upAdd = e.target.closest('[data-rdm-up-add]');
  if (upAdd) {
    const box = upAdd.closest('[data-rdm-upsell]');
    const sel = [...box.querySelectorAll('.rdm-up__item input:checked')];
    if (!sel.length) return;
    upAdd.disabled = true;
    upAdd.textContent = 'Ajout en cours…';
    try {
      await addItems(sel.map((b) => ({ id: +b.value, quantity: 1 })), upAdd);
    } catch (ex) {
      const hint = box.querySelector('[data-rdm-up-hint]');
      if (hint) hint.textContent = ex.message;
      upAdd.disabled = false;
      upAdd.textContent = 'Réessayer';
    }
  }
});

document.addEventListener('change', (e) => {
  const t = e.target;
  if (!(t instanceof HTMLInputElement)) return;
  const dialog = t.closest('.rdm-pack');
  if (dialog) { renderPack(dialog); return; }
  const box = t.closest('[data-rdm-upsell]');
  if (!box) return;
  const sel = [...box.querySelectorAll('.rdm-up__item input:checked')];
  const btn = box.querySelector('[data-rdm-up-add]');
  const hint = box.querySelector('[data-rdm-up-hint]');
  const n = +box.dataset.count || 0;
  const total = +box.dataset.total || 0;
  const k = sel.length;
  btn.disabled = k === 0;
  btn.textContent = k === 0 ? 'Cochez un ou plusieurs stickers' : `Ajouter ${k} ${plural(k, 'sticker', 'stickers')} au panier`;
  if (!hint) return;
  if (k === 0) { hint.textContent = ''; return; }
  const gain = Math.floor((n + k) / 3) - Math.floor(n / 3);
  const add = sel.reduce((a, b) => a + +b.dataset.price, 0);
  const parts = [];
  if (gain > 0) parts.push(gain > 1 ? `${gain} stickers offerts` : '1 sticker offert');
  const maxSel = Math.max(...sel.map((b) => +b.dataset.price));
  if (total < SEUIL && total + add - (gain > 0 ? maxSel * gain : 0) >= SEUIL) parts.push('livraison offerte');
  hint.textContent = parts.length ? 'Avec cette sélection : ' + parts.join(' et ') + ' !' : '';
});
